/******************
*
* Newsletter signup management
*
* Documentation: see `newsletter.README.md`
*
*/

if (typeof FN == 'undefined') FN = {};


FN.newsletterConfig = {
  instances: [],
  messages: {
    pleaseProvideEmailAddress: "Please provide a valid email address.",
    pleaseAcceptPrivacyPolicy: "Please read and accept our Privacy Policy.",
    pleaseAcceptTerms: "Please read and accept our terms.",
    pleaseCheckRequiredTags: "If you want to hear from us, please select the options above."
  },
  selectors: {
    formClass: 'newsletter-form',
    emailInput: 'input[name="email"]',
    tagItemClass: 'signup-tag__item',
    consentItemClass: 'consent__item',
    consentTextClass: 'consent__text',
    subscriptionProfileFormID: 'newsletter-form--profile'
  },
  formStatus: {
    error: 'error',
    loading: 'loading',
    success: 'success'
  }
}


FN.newsletter = function (element) {
  /****************
  * Initialization
  */
  this.__init = function (element) {
    this.baseElement = element;

    this.startData = this.serializeArray(this.baseElement);
    this.baseElement.addEventListener('submit', this.submit.bind(this));
  };

  this.serializeArray = function(formElement) {
    var values = [];
    var formData = new FormData(formElement);
    formData.forEach(function(value, key) {
      values.push({ name: key, value: value });
    });
    return values;
  };


  /**
  * Submit the form data
  */
  this.submit = function (event) {
    event.preventDefault();

    var formStatus = this.validateForm();
    if (formStatus.status === FN.newsletterConfig.formStatus.error) {
      this.displayFormStatus(formStatus);
      return false;
    }

    var requestURL = this.prepareRequestURL();
    var requestData = this.prepareFormData();
    var requestOptions = this.prepareRequestOptions();

    this.baseElement.querySelectorAll('input[type="submit"]').forEach(function(input) {
      input.setAttribute('disabled', 'disabled');
    });

    FN.remoteRequest.sendRequest(requestURL, requestData, requestOptions);
  };


  /**
  * Validate the form before submitting
  */
  this.validateForm = function () {
    var formStatus = { 'status': false, 'messages': [] };

    // check email
    var emailInput = this.baseElement.querySelector(FN.newsletterConfig.selectors.emailInput);
    var emailValue = emailInput ? emailInput.value : '';
    if (!emailValue.match(/^.+@.+\..+/g)) {
      formStatus.messages.push({ 'message': FN.newsletterConfig.messages.pleaseProvideEmailAddress });
    }

    // check that tags are selected
    var tagItems = this.baseElement.querySelectorAll('.' + FN.newsletterConfig.selectors.tagItemClass);
    for (var i = 0; i < tagItems.length; i++) {
      var requiredTagAttr = tagItems[i].dataset.required;
      var requiredTag = requiredTagAttr !== undefined && requiredTagAttr !== '' && requiredTagAttr !== 'false' && requiredTagAttr !== '0';
      if (requiredTag && !tagItems[i].checked) {
        formStatus.messages.push({ 'message': FN.newsletterConfig.messages.pleaseCheckRequiredTags });
      }
    }

    // check consent / privacy policy
    var consentItems = this.baseElement.querySelectorAll('.' + FN.newsletterConfig.selectors.consentItemClass);
    for (var c = 0; c < consentItems.length; c++) {
      var requiredConsentAttr = consentItems[c].dataset.required;
      var requiredConsent = requiredConsentAttr !== undefined && requiredConsentAttr !== '' && requiredConsentAttr !== 'false' && requiredConsentAttr !== '0';
      if (requiredConsent && !consentItems[c].checked) {
        if (consentItems[c].getAttribute('id') === 'consent--privacy') {
          formStatus.messages.push({ 'message': FN.newsletterConfig.messages.pleaseAcceptPrivacyPolicy });
        } else {
          formStatus.messages.push({ 'message': FN.newsletterConfig.messages.pleaseAcceptTerms });
        }
      }
    }

    if (formStatus.messages.length == 0) {
      formStatus.status = FN.newsletterConfig.formStatus.success;
    } else {
      formStatus.status = FN.newsletterConfig.formStatus.error;
    }

    return formStatus;
  };


  /**
  * Collect and prepare form data
  */
  this.prepareFormData = function () {
    var formData = this.serializeArray(this.baseElement);

    // go through all tag items (checkboxes) and find those that are NOW UNSELECTED
    this.baseElement.querySelectorAll('.' + FN.newsletterConfig.selectors.tagItemClass).forEach(function (element) {
      var wasCheckedAtStart = (element.getAttribute('data-start-value') == 1);
      var isCheckedNow = element.checked;
      if (wasCheckedAtStart && !isCheckedNow) {
        var tagName = element.getAttribute('data-tag-name');
        formData.push({ name: 'removeTags[]', value: tagName });
      }
    });

    // get consent text + date
    var consentText = '';
    this.baseElement.querySelectorAll('.' + FN.newsletterConfig.selectors.consentTextClass).forEach(function (element) {
      if (element.checked) {
        if (consentText !== '') consentText += ' ';
        var label = element.closest('label');
        if (label) consentText += label.textContent;
      }
    });
    if (consentText) {
      formData.push({ name: 'consent[date]', value: (new Date()).toUTCString() });
      formData.push({ name: 'consent[text]', value: consentText });
    }

    return formData;
  };


  /**
  * Configure request options
  */
  this.prepareRequestOptions = function () {
    var messageContainer = this.baseElement.querySelector('.request-notice');
    var requestOptions = {
      'responseContainer': messageContainer,
      'onComplete': this.handleFormResponse.bind(this),
      'redirectOnSuccess': false
    };

    return requestOptions;
  };


  /**
  * Choose the correct request URL
  */
  this.prepareRequestURL = function () {
    var requestURL = FN.config.urls.apiBase;

    var subscriptionStatus = this.baseElement.getAttribute('data-subscription-status');
    if (subscriptionStatus === 'subscribed') {
      requestURL += FN.config.urls.apiContactUpdate;
    } else {
      requestURL += FN.config.urls.apiContactSubscribe;
    }

    return requestURL;
  };


  /**
  * Display the status of the form
  */
  this.displayFormStatus = function (formStatus) {
    var messageContainer = this.baseElement.querySelector('.request-notice');
    if (!messageContainer) return;

    var messageHtml = '';
    for (var i = 0; i < formStatus.messages.length; i++) {
      messageHtml += '<p>' + formStatus.messages[i].message + '</p>';
    }

    messageContainer.innerHTML = messageHtml;
    messageContainer.classList.remove('success', 'error', 'loading');
    messageContainer.classList.add(formStatus.status);

    if (formStatus.messages.length == 0) {
      messageContainer.style.display = 'none';
    } else {
      messageContainer.style.display = '';
    }
  };


  /**
  * Handle the request response
  */
  this.handleFormResponse = function (xhr, options) {
    this.baseElement.querySelectorAll('input[type="submit"]').forEach(function(input) {
      input.removeAttribute('disabled');
    });

    if (xhr.status < 400) {
      var context = { 'responseData': xhr, 'formElement': this.baseElement, 'options': options };

      // Compatible custom event for legacy listeners
      document.dispatchEvent(new CustomEvent('FN.newsletter:success', { detail: context }));

      // Create and dispatch native event for non-legacy listeners
      document.dispatchEvent(new CustomEvent('TowerNewsletterSubscribed', {
        detail: context
      }));
    }
  };


  /*****************
  * Constructor
  */
  this.__init(element);
};
